import { useParams } from 'react-router-dom';

export const useCurrentCustomerIdMaybe = (): number | undefined => {
  const { customerId } = useParams();

  return customerId !== undefined ? Number(customerId) : undefined;
};
